<mat-toolbar class="topbar horizontal-topbar">
  <div class="container">
    <div class="d-none d-sm-flex">
      <app-branding></app-branding>
    </div>

    <!-- Mobile Menu -->
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="d-block d-lg-none"
    >
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    <!-- --------------------------------------------------------------- -->

    <div class="d-none d-lg-flex">
      <!-- --------------------------------------------------------------- -->
      <!--  Links -->
      <!-- --------------------------------------------------------------- -->
      <button
        mat-button
        [matMenuTriggerFor]="appsmenu"
        aria-label="Notifications"
      >
        <div class="d-flex align-items-center">
          Apps <i-tabler name="chevron-down" class="icon-16 m-l-4"></i-tabler>
        </div>
      </button>
      <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
        <div class="row">
          <div class="col-sm-8 b-r-1 p-r-0">
            <div class="p-32 p-b-0">
              <div class="row">
                @for(appdd of apps; track appdd.title) {
                <div class="col-sm-6 text-hover-primary">
                  <a
                    [routerLink]="[appdd.link]"
                    class="d-flex align-items-center text-decoration-none m-b-24"
                  >
                    <span
                      class="text-primary bg-light-primary rounded icon-40 d-flex align-items-center justify-content-center"
                    >
                      <img [src]="appdd.img" width="20" />
                    </span>

                    <div class="m-l-16">
                      <h5
                        class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text"
                      >
                        {{ appdd.title }}
                      </h5>
                      <span class="mat-body-1 f-s-12">{{
                        appdd.subtitle
                      }}</span>
                    </div>
                  </a>
                </div>
                }
              </div>
            </div>
            <div
              class="b-t-1 p-24 d-none d-lg-flex align-items-center justify-content-between"
            >
              <span
                class="d-flex align-items-center mat-subtitle-1 f-s-16 f-w-500"
              >
                <i-tabler name="help" class="icon-20 m-r-8"></i-tabler
                >Frequently Asked Questions
              </span>
              <a
                [routerLink]="['/theme-pages/faq']"
                mat-flat-button
                color="primary"
                >Check</a
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="p-x-16 p-y-32">
              <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-16">Quick Links</h4>
              @for(quicklink of quicklinks; track quicklink.title) {
              <div class="text-hover-primary">
                <a
                  [routerLink]="[quicklink.link]"
                  class="hover-text text-decoration-none mat-body-1 f-w-600 d-block p-y-8"
                  >{{ quicklink.title }}</a
                >
              </div>
              }
            </div>
          </div>
        </div>
      </mat-menu>
      <a mat-button [routerLink]="['/apps/chat']">Chat</a>
      <a mat-button [routerLink]="['/apps/calendar']">Calendar</a>
      <a mat-button [routerLink]="['/apps/email/inbox']">Email</a>
    </div>

    <span class="flex-1-auto"></span>

    <!-- Mobile Menu -->
    <button
      mat-icon-button
      (click)="toggleMobileFilterNav.emit()"
      class="d-flex d-lg-none justify-content-center"
    >
      <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
    </button>

    <!-- --------------------------------------------------------------- -->
    <!-- langugage Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
      <img
        [src]="selectedLanguage.icon"
        class="rounded-circle object-cover icon-20"
      />
    </button>
    <mat-menu #flags="matMenu" class="cardWithShadow">
      @for(lang of languages; track lang.icon) {
      <button mat-menu-item (click)="changeLanguage(lang)">
        <div class="d-flex align-items-center">
          <img
            [src]="lang.icon"
            class="rounded-circle object-cover m-r-8 icon-20"
          />
          <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
        </div>
      </button>
      }
    </mat-menu>

    <a
      mat-icon-button
      routerLink="/apps/users/account"
      aria-label="Account settings"
      class="header-settings-btn"
    >
      <i-tabler name="settings" class="icon-16 d-flex"></i-tabler>
    </a>

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="profilemenu"
      aria-label="Profile"
      class="header-avatar-btn"
    >
      <img
        *ngIf="avatarUrl"
        [src]="avatarUrl"
        class="rounded-circle object-cover"
        width="32"
        height="32"
        alt=""
      />
      <span *ngIf="!avatarUrl" class="header-avatar-initials">{{ userInitials }}</span>
    </button>
    <mat-menu
      #profilemenu="matMenu"
      xPosition="before"
      class="profile-menu cardWithShadow"
    >
      <div class="profile-menu-head">
        <img
          *ngIf="avatarUrl"
          [src]="avatarUrl"
          class="profile-menu-avatar"
          alt=""
        />
        <span *ngIf="!avatarUrl" class="profile-menu-avatar profile-menu-avatar--initials">{{ userInitials }}</span>
        <div class="profile-menu-meta">
          <div class="profile-menu-name">{{ user.first_name }} {{ user.last_name }}</div>
          <div class="profile-menu-role" *ngIf="user.role">{{ user.role }}</div>
          <div class="profile-menu-email" *ngIf="user.email">
            <i-tabler name="mail" class="icon-15"></i-tabler>
            {{ user.email }}
          </div>
        </div>
      </div>

      <div class="profile-menu-links">
        @for(profile of profiledd; track profile.title) {
        <a class="profile-menu-link" [routerLink]="[profile.link]">
          <span class="profile-menu-link-icon">
            <img [src]="profile.img" width="16" alt="" />
          </span>
          <span class="profile-menu-link-text">
            <span class="profile-menu-link-title">{{ profile.title }}</span>
            <span class="profile-menu-link-sub">{{ profile.subtitle }}</span>
          </span>
        </a>
        }
      </div>

      <div class="profile-menu-actions">
        <a
          [routerLink]="['/authentication/login']"
          mat-stroked-button
          color="primary"
          class="profile-menu-logout"
        >Logout</a>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>
